/* eslint-disable no-implicit-coercion */

// These versions should be the version that the deprecation was _introduced_,
// not the version that the feature will be removed.

const ASSIGN = !!'4.0.0-beta.1';

export { ASSIGN };
